
import { Vue, Prop, Component } from 'nuxt-property-decorator'

@Component
export default class BlackFridayCompareCard extends Vue {
  @Prop({ type: String, required: true })
  readonly image!: string

  @Prop({ type: String, required: true })
  readonly title!: string

  @Prop({ type: String, required: true })
  readonly url!: string
}
